export default __webpack_public_path__ + "static/media/697.36ae82a5.jpg";